/** Relatório mensal para o cliente ("o que fizemos por você"). */
import { z } from 'zod';
import { DataISO, Id } from './comum.js';
import { TarefaStatus } from './enums.js';

export const MesQuery = z.object({ mes: z.string().regex(/^\d{4}-\d{2}$/, 'mês no formato AAAA-MM') });
export const PublicarBody = MesQuery.extend({ exigirCiencia: z.boolean().default(false) });

export const RelatorioMensal = z.object({
  mes: z.string(),
  escritorio: z.string(),
  cliente: z.object({ id: Id, nome: z.string(), razaoSocial: z.string(), documento: z.string(), regime: z.string().nullable() }),
  resumo: z.object({ total: z.number().int(), noPrazo: z.number().int(), comAtraso: z.number().int(), dispensadas: z.number().int(), abertas: z.number().int(), guias: z.number().int(), valorGuias: z.number(), valorPago: z.number() }),
  obrigacoes: z.array(z.object({
    id: Id, titulo: z.string(), obrigacaoSigla: z.string().nullable(), obrigacaoNome: z.string().nullable(), competenciaLabel: z.string().nullable(), vencimento: DataISO, status: TarefaStatus,
    concluidaEm: z.string().nullable(), concluidaComAtraso: z.boolean().nullable(), motivoDispensa: z.string().nullable(),
    entregas: z.array(z.object({ tipo: z.string(), protocolo: z.string().nullable(), dataTransmissao: DataISO.nullable(), valorTotal: z.number().nullable(), vencimentoGuia: DataISO.nullable(), dataPagamento: DataISO.nullable(), codigoReceita: z.string().nullable() })),
  })),
  solicitacoes: z.array(z.object({ titulo: z.string(), criadoEm: z.string(), status: z.string(), respondidaEm: z.string().nullable() })),
  processos: z.array(z.object({ titulo: z.string(), fluxoNome: z.string(), status: z.string(), encerradoEm: z.string().nullable() })),
  geradoEm: z.string(),
});
export type RelatorioMensal = z.infer<typeof RelatorioMensal>;
